/**
 * Update date: 24-05-2023
 * Screen 2033.3
 */
import React, { useRef } from 'react';
import { DataGridFull } from 'app/components/DataGrid';
import useFormatTime from 'hooks/useFormatTime';
import useFormat from 'hooks/useFormat';
import moment from 'moment';
import { useOrderDetail } from '..';
import useDictionary from 'hooks/useDictionary';
import { VENDOR_STATUS } from 'constant/dataConstant';
import { useApp } from 'app';

function SpecialDealTable(props) {
  const { themePro }: any = useApp();
  const { DateFormat, DateTimeFormat } = useFormatTime();
  const { AmountFormat, DoubleFormat, QtyFormat } = useFormat();
  const dataGridRef: any = useRef(null);
  const context: any = useOrderDetail();
  const { orderData, loadingDeliver } = context;

  const { t }: any = useDictionary({
    programId: '2033.3',
  });

  /**
   * render order progress
   *
   * @param {*} e
   * @return {*}
   */
  const renderOrderProgress = e => {
    return t(VENDOR_STATUS?.[e?.value] || '');
  };

  const columns: any = [
    {
      caption: t('Order'),
      alignment: 'center',
      items: [
        {
          dataField: 'waybill',
          caption: t('WayBill'),
        },
        {
          dataField: 'receivebill',
          caption: t('Bill ID'),
        },
        {
          dataField: 'duedate',
          caption: t('Date'),
          dataType: 'date',
          format: DateFormat,
          alignment: themePro ? 'left' : 'center',
        },
        {
          dataField: 'vendornm',
          caption: t('Vendor'),
        },
        {
          dataField: 'storenm',
          caption: t('Store'),
        },
        {
          dataField: 'sendduedate',
          caption: t('Send Due Date'),
          dataType: 'date',
          format: DateFormat,
          alignment: themePro ? 'left' : 'center',
        },
        {
          dataField: 'ordnumber',
          caption: t('Order Number'),
          alignment: themePro ? 'left' : 'center',
        },
        {
          dataField: 'progress',
          caption: t('Progress'),
          cellRender: renderOrderProgress,
        },
      ],
    },
    {
      caption: t('Product'),
      alignment: 'center',
      columns: [
        {
          dataField: 'productcd',
          caption: t('Product code'),
          alignment: themePro ? 'left' : 'center',
        },
        {
          dataField: 'productnm',
          caption: t('Product Name'),
        },
        {
          dataField: 'marketablesz',
          caption: t('Marketable Size'),
          // alignment: themePro ? 'left' : 'center',
        },
        {
          dataField: 'optioncd',
          caption: t('Option Code'),
          visible: false,
          // alignment: themePro ? 'left' : 'center',
        },
        {
          dataField: 'optionnm',
          caption: t('Option'),
          // alignment: themePro ? 'left' : 'center',
        },
        {
          dataField: 'qtyperpack',
          caption: t('Quantity Per Pack'),
          dataType: 'number',
          format: QtyFormat,
        },
      ],
    },
    {
      caption: t('Content'),
      alignment: 'center',
      columns: [
        {
          dataField: 'purchaseunitprice',
          caption: t('Purchase Unit Price'),
          dataType: 'number',
          format: AmountFormat,
        },
        {
          dataField: 'qty',
          caption: t('Qty'),
          dataType: 'number',
          format: QtyFormat,
        },
        {
          dataField: 'ea',
          caption: t('Ea'),
          dataType: 'number',
          format: QtyFormat,
        },
        {
          dataField: 'amount',
          caption: t('Amount'),
          dataType: 'number',
          format: AmountFormat,
        },
        {
          dataField: 'supplyamount',
          caption: t('Supply Amount'),
          dataType: 'number',
          format: AmountFormat,
        },
        {
          dataField: 'vat',
          caption: t('VAT'),
          dataType: 'number',
          format: AmountFormat,
        },
        {
          dataField: 'bottle',
          caption: t('Bottle'),
          dataType: 'number',
          format: DoubleFormat,
        },
        {
          dataField: 'container',
          caption: t('Container'),
          dataType: 'number',
          format: DoubleFormat,
        },
        {
          dataField: 'gtotal',
          caption: t('G.Total'),
          dataType: 'number',
          format: AmountFormat,
        },
      ],
    },
    {
      dataField: 'billnote',
      caption: t('Bill Note'),

      visible: false,
    },
    {
      dataField: 'linenote',
      caption: t('Line Note'),
      visible: false,
    },
    {
      dataField: 'bottlenm',
      caption: t('Bottle ID'),
      visible: false,
    },
    {
      dataField: 'bottleunitprice',
      caption: t('Bottle Unit Price'),
      visible: false,
    },
    {
      dataField: 'containerunitprice',
      caption: t('Container Unit Price'),
      visible: false,
    },
    {
      dataField: 'mkr',
      caption: t('Maker'),
      visible: false,
    },
    {
      dataField: 'org',
      caption: t('Origin'),
      visible: false,
    },
    {
      dataField: 'defvendornm',
      caption: t('Default Vendor'),
      visible: false,
    },
    {
      dataField: 'lgcate',
      caption: t('Large category'),
      visible: false,
    },
    {
      dataField: 'mdcate',
      caption: t('Medium category'),
      visible: false,
    },
    {
      dataField: 'smcate',
      caption: t('Small category'),
      visible: false,
    },
    {
      dataField: 'subcate',
      caption: t('Sub category'),
      visible: false,
    },
    {
      dataField: 'registerdm',
      caption: t('Register Date&Time'),
      dataType: 'date',
      alignment: themePro ? 'left' : 'center',
      format: DateTimeFormat,
      visible: false,
    },
    {
      dataField: 'registerusernm',
      caption: t('Register User'),
      visible: false,
    },
    {
      dataField: 'registerprogramnm',
      caption: t('Register Program ID'),
      alignment: 'left',
      visible: false,
    },
    {
      dataField: 'modifydm',
      caption: t('Modify Date&Time'),
      dataType: 'date',
      alignment: themePro ? 'left' : 'center',
      format: DateTimeFormat,
      visible: false,
    },
    {
      dataField: 'modifyusernm',
      caption: t('Modify User'),
      visible: false,
    },
    {
      dataField: 'modifyprogramnm',
      caption: t('Modify Program ID'),
      alignment: 'left',
      visible: false,
    },
  ];
  /**
   * on export excel
   *
   */
  const exportExcel = () => {
    dataGridRef?.current?.instance?.exportToExcel();
  };
  const exportFileName =
    'SMDC_2033.3 Order Consignment Delivery Detail Inquiry ' +
    moment().format('YYYYMMDD');

  return (
    <>
      <DataGridFull
        storageKeyInquiry
        columns={columns}
        ref={dataGridRef}
        dataSource={orderData}
        options={{
          columnAutoWidth: true,
          onToolbarPreparing: (e: any) => {
            e.toolbarOptions.items.unshift(
              {
                location: 'before',
                template: 'totalCount',
              },
              {
                location: 'before',
                widget: 'dxButton',
                options: {
                  icon: 'xlsxfile',
                  text: t('Export Excel'),
                  disabled: !orderData,
                  onClick: () => exportExcel(),
                },
              },
            );
          },
          export: {
            fileName: exportFileName,
          },
          summary: {
            totalItems: [
              {
                name: 'qty',
                column: 'qty',
                valueFormat: QtyFormat,
                displayFormat: '{0}',
                summaryType: 'sum',
              },
              {
                name: 'ea',
                column: 'ea',
                valueFormat: QtyFormat,
                displayFormat: '{0}',
                summaryType: 'sum',
              },
              {
                name: 'amount',
                column: 'amount',
                valueFormat: AmountFormat,
                displayFormat: '{0}',
                summaryType: 'sum',
              },
              {
                name: 'supplyamount',
                column: 'supplyamount',
                valueFormat: AmountFormat,
                displayFormat: '{0}',
                summaryType: 'sum',
              },
              {
                name: 'vat',
                column: 'vat',
                valueFormat: AmountFormat,
                displayFormat: '{0}',
                summaryType: 'sum',
              },
              {
                name: 'bottle',
                column: 'bottle',
                valueFormat: AmountFormat,
                displayFormat: '{0}',
                summaryType: 'sum',
              },
              {
                name: 'contatiner',
                column: 'container',
                valueFormat: AmountFormat,
                displayFormat: '{0}',
                summaryType: 'sum',
              },
              {
                name: 'gtotal',
                column: 'gtotal',
                valueFormat: AmountFormat,
                displayFormat: '{0}',
                summaryType: 'sum',
              },
            ],
          },
        }}
      />
    </>
  );
}

export default SpecialDealTable;
